import { useQuery } from '@tanstack/react-query';

import { fetchResources } from ':cloud/queries/ResourceQueries/useGetResources';
import { QueryKey } from ':cloud/queries/types';
import { ICluster } from ':cloud/types/ts_types';

export function useGetResources(): {
  isLoading: boolean;
  resources: ICluster[];
} {
  const { isLoading, data } = useQuery({
    queryKey: [QueryKey.internal, QueryKey.resources],
    queryFn: async () => fetchResources(true),
    staleTime: Infinity,
    retry: 3,
  });

  return {
    isLoading,
    resources: data?.resources || [],
  };
}
